module.exports = __webpack_public_path__ + "static/18-e39f6d49f3c8c7273d32fe07becd9f81.jpg";